"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _productPositionSelectors = require("../../redux/selectors/productPositionSelectors");
var _positionActions = require("../../redux/actions/positionActions");
var _BalancesMenuComponent = _interopRequireDefault(require("./BalancesMenuComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state) {
  var positions = (0, _productPositionSelectors.productPositionAssetsSelector)(state);
  var position = state.apexCore.position;
  var selectedProductId = position.selectedProductId;
  return {
    positions: positions,
    selectedProductId: selectedProductId
  };
};
var mapDispatchToProps = {
  selectPositionAndSave: _positionActions.selectPositionAndSave
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_BalancesMenuComponent["default"]);